// Connects AVI to the JustLyrics API database

const DB_URL = "https://v2.betterbase.kaywat.codes/rest/v1";

const headers = {
    "Content-Type": "application/json"
};

export async function fetchLyrics(trackName: string, artistName?: string) {
    try {
        let queryUrl = `${DB_URL}/tracks?track_name=ilike.*${encodeURIComponent(trackName)}*`;
        if (artistName) {
            queryUrl += `&artist_name=ilike.*${encodeURIComponent(artistName)}*`;
        }
        queryUrl += "&select=track_name,artist_name,lyrics&limit=1";

        const res = await fetch(queryUrl, { headers });
        if (!res.ok) return null;
        
        const data = await res.json();
        if (data && data.length > 0) {
            return {
                track: data[0].track_name,
                artist: data[0].artist_name,
                lyrics: data[0].lyrics
            };
        }
    } catch (err) {
        console.warn("[Harness: JustLyrics] Failed to fetch lyrics", err);
    }
    return null;
}

const SUPABASE_URL = 'https://euneewmscrkvpngvjepd.supabase.co';
const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV1bmVld21zY3JrdnBuZ3ZqZXBkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODI3ODg1MjMsImV4cCI6MjA5ODM2NDUyM30.TV7Lp7jwUzPYf1yaCNxWpY3oTtDGPSokYssDjakHrr0';

export async function toggleLikeSong(trackName: string, liked: boolean) {
    try {
        const cleanTrack = trackName.replace(/by/gi, '').trim();
        const queryUrl = `${SUPABASE_URL}/rest/v1/songs?title=ilike.*${encodeURIComponent(cleanTrack)}*`;
        
        const res = await fetch(queryUrl, {
            method: 'PATCH',
            headers: {
                "Content-Type": "application/json",
                "apikey": SUPABASE_KEY,
                "Authorization": `Bearer ${SUPABASE_KEY}`,
                "Prefer": "return=minimal"
            },
            body: JSON.stringify({ liked: liked })
        });
        
        return res.ok;
    } catch (err) {
        console.warn("[Harness: JustLyrics] Failed to like song", err);
        return false;
    }
}

export async function fetchLikedSongs() {
    try {
        const queryUrl = `${SUPABASE_URL}/rest/v1/songs?liked=eq.true&select=*`;
        const res = await fetch(queryUrl, {
            method: 'GET',
            headers: {
                "apikey": SUPABASE_KEY,
                "Authorization": `Bearer ${SUPABASE_KEY}`
            }
        });
        
        if (res.ok) {
            return await res.json();
        }
        return [];
    } catch (err) {
        console.warn("[Harness: JustLyrics] Failed to fetch liked songs", err);
        return [];
    }
}
